import voucherSaga from './saga';

export default voucherSaga;
